module.exports = __webpack_public_path__ + "src/assets/img/smarteyes.89731342.png";